import { render } from "./VacunaPersTabla03.vue?vue&type=template&id=2b87b2cc&scoped=true"
import script from "./VacunaPersTabla03.vue?vue&type=script&lang=js"
export * from "./VacunaPersTabla03.vue?vue&type=script&lang=js"

import "./VacunaPersTabla03.vue?vue&type=style&index=0&id=2b87b2cc&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b87b2cc"]])

export default __exports__